import {getCurrentYear} from '../../utils/commons'
import TopMotorGearChoiceLogo from './logo'
import {topMotorGearChoiceStylesUS} from './styles'

const baseConfig = {
  domainName: 'topmotorgearchoice' as const,
  domainType: 'picks' as const,
  siteName: 'Top Motor Gear Choice',
  logo: <TopMotorGearChoiceLogo className="size-12 shrink-0 tablet:size-10" />,
  favicon: '/favicons/topmotorgearchoice.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-4S0FS8HYN0',
    camelCaseUrl: 'TopMotorGearChoice.com',
    title: (_category: string, count: string) =>
      `Top ${count} Automotive Products ${getCurrentYear()} in the US | TopMotorGearChoice.com – Expert Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `At TopMotorGearChoice.com, we review and compare the best automotive products of ${getCurrentYear()} in the US. Discover expert insights, detailed comparisons, and top-rated gear to enhance your driving experience with confidence.`,
    styles: topMotorGearChoiceStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
